import { create } from 'zustand';
import type { PaymentCurrency, PaymentOrderStatus } from '@shared/types';
import { useShellStore } from '@renderer/app/state/shell-store';

export type PaymentsSort = 'updatedAt' | 'amount' | 'status';
export type PaymentEditorTab = 'general' | 'contract' | 'evidence';

interface PaymentsViewStore {
  statusFilter: 'all' | PaymentOrderStatus;
  customerFilter: 'all' | string;
  currencyFilter: 'all' | PaymentCurrency;
  sort: PaymentsSort;
  editorTab: PaymentEditorTab;
  setStatusFilter: (value: 'all' | PaymentOrderStatus) => void;
  setCustomerFilter: (value: 'all' | string) => void;
  setCurrencyFilter: (value: 'all' | PaymentCurrency) => void;
  setSort: (value: PaymentsSort) => void;
  setEditorTab: (value: PaymentEditorTab) => void;
  setViewMode: (value: 'grid' | 'list') => Promise<void>;
}

export const usePaymentsViewStore = create<PaymentsViewStore>((set) => ({
  statusFilter: 'all',
  customerFilter: 'all',
  currencyFilter: 'all',
  sort: 'updatedAt',
  editorTab: 'general',
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setCustomerFilter: (customerFilter) => set({ customerFilter }),
  setCurrencyFilter: (currencyFilter) => set({ currencyFilter }),
  setSort: (sort) => set({ sort }),
  setEditorTab: (editorTab) => set({ editorTab }),
  setViewMode: async (paymentsViewMode) => {
    await useShellStore.getState().savePreferences({ paymentsViewMode });
  }
}));
